import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || 'https://xaintro-backend.onrender.com';

const api = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Add token to requests
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

const dashboardService = {
  getStats: async () => {
    const response = await api.get('/admin/stats');
    return response.data;
  },
};

export default dashboardService;
